import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useEffect } from 'react';

// import { useWindowSize } from '#hooks/index';
import Layout from '#layout/index';

const WhatsAppLogo = dynamic(import('#layout/helpers').then(mod => mod.WhatsAppLogo));
const Information = dynamic(import('#app/pages/contactanos-old/information'));
const WhyLearn = dynamic(import('#app/pages/home/why-learn'));
const ImageText = dynamic(import('#app/templates/new-image-text'));
const Typography = dynamic(import('#app/UI/atoms/new-typography'));
// const Button = dynamic(import('#app/UI/molecules/button/button'));

const SuccessClaim = () => {
  // const { isDesktop } = useWindowSize();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Head>
        <title>Contáctanos | Crack The Code</title>
        <meta
          name="description"
          content="Somos una academia online que empodera a niños y jóvenes a través del código y la tecnología ¡Contáctanos para saber más!"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Layout mainType="full_variant">
        <ImageText
          first="text"
          image={{
            image: ['/contactanos/desktop.webp', '/contactanos/desktop.webp'],
            width: [520, '100%'],
            height: [502, 343]
          }}
          className="pt-40 sm_pt-0 sm_px-20 gap-x-120 gap-y-40 sm_gap-y-20"
          maxWidth="1276px"
        >
          <Typography
            className="typo-56 font-bold mb-24 sm_mb-16"
            tag="h2"
            style={{ color: '#583AF0' }}
          >
            ¡Gracias!
          </Typography>

          <Typography className="typo-32 font-bold mb-24 sm_mb-16" tag="p">
            Pronto nos comunicaremos contigo
          </Typography>

          {/* <Typography className="typo-24 mb-24" tag="p">
            Lorem ipsum dolor sit amet consectetur. Risus at pellentesque id commodo
            rhoncus. Sit mi leo eget morbi elit egestas dolor.
          </Typography> */}

          {/* <div className="flex w-full justify-end">
            <Button
              type="redirect"
              href="/cursos"
              variant="black"
              width={isDesktop ? '302px' : '100%'}
              height="48px"
              textOptions={{ className: 'type-16 font-bold' }}
            >
              Explorar los cursos
            </Button>
          </div> */}
        </ImageText>

        <Information />

        <WhyLearn />

        <WhatsAppLogo fixLanding />
      </Layout>
    </>
  );
};

export default SuccessClaim;
